module.exports = __webpack_public_path__ + "17c45b8d438a341b7ed71d138d8d8f3b.fbx";